import React, { useEffect, useState } from "react";
import Skeleton from "@mui/material/Skeleton";

const GetAfsoo = ({ dist_code, onLoadingChange, onChange }) => {
  const [options, setOptions] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!dist_code) return;

    const fetchAFSO = async () => {
      try {
        setLoading(true);
        onLoadingChange(true);

        const response = await fetch(
          `${process.env.REACT_APP_URL_HEADER}/Common/getAfso?dist_code=${dist_code}`
        );
        const data = await response.text();
        setOptions(data);
      } catch (error) {
        console.error("Error fetching AFSO:", error);
      } finally {
        setLoading(false);
        onLoadingChange(false);
      }
    };

    fetchAFSO();
  }, [dist_code, onLoadingChange]);

  const handleSelect = (e) => {
    const afso_code = e.target.value;
    if (onChange) onChange(afso_code);
  };

  return (
    <div>
      {loading ? (
        <Skeleton width={100} height={40} />
      ) : (
        <select
          name="afso_code"
          id="afso_code"
          onChange={handleSelect}
          dangerouslySetInnerHTML={{ __html: options }}
        />
      )}
    </div>
  );
};

export default GetAfsoo;

